module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_mitosis_12-420e8ad03760a717cdb07ecdf8710e69.jpg";